import {useDispatch, useSelector} from "react-redux";
import Platform from "../logic/platform/platform";
import {setLayoutPref} from "../../redux/slice/authSlice";

const useLayoutPref = () => {

    const pref = useSelector(
        state => state.local.auth.layoutPref
    );
    const dispatch = useDispatch();

    if(Platform.isMobile()) {
        return ["List", () => {}];
    }

    const layoutPref = pref || "Grid";

    const aFunc = (l) => {
        dispatch(setLayoutPref(l));
    }

    return [layoutPref, aFunc]
}

export default useLayoutPref;
